import { useCallback, useState } from "react";

export const useModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onShowModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const onHideModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return {
    isModalOpen,
    onShowModal,
    onHideModal,
  };
};
